import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist';

import { auth } from './auth';
import { sso } from './sso';
import { topbar } from './layout/topbar-layout.module';
import session from './session';

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
});

// Create a new store instance or import from module.
const store = createStore({
    /* state, actions, mutations */
    modules: {
        auth,
        sso,
        topbar,
        session,
    },
    plugins: [vuexLocal.plugin],
});

export default store;
